export default __webpack_public_path__ + "static/media/detail_big_15_4.562d438e.jpg";